import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import React, { useState } from "react";
import { ShowcaseProjectItem } from "./ShowcaseProjectItem";

export const ShowcaseGroupItem = (props) => {
  const [isExpanded, setIsExpanded] = useState(props.expandedByDefault);

  const toggleGroupVisiblity = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="showcase-group-item">
      <div className="d-flex flex-row showcase-cat-header align-items-center">
        <div className="hline left" onClick={toggleGroupVisiblity} />
        <div
          onClick={(e) => {
            setIsExpanded(!isExpanded);
          }}
          className="p-1 text-nowrap"
        >
          {props.heading}
        </div>
        <div className="hline right" onClick={toggleGroupVisiblity} />
        <div onClick={toggleGroupVisiblity} className="p-1">
          <FontAwesomeIcon icon={isExpanded ? faAngleUp : faAngleDown} />
        </div>
      </div>
      {isExpanded &&
        props.data.map((project) => {
          return (
            <ShowcaseProjectItem
              url={project.video_link}
              heading={project.heading}
              description={project.description}
              paymentStatus={project.payment}
              isAssignment={project.isAssignment}
            />
          );
        })}
    </div>
  );
};
export default ShowcaseGroupItem;
